import {
    CLEAR_GROUP_AUDIENCE_RETARGETING_EDITOR_CONDITION,
    ClearGroupAudienceRetargetingEditorCondition,
    OPEN_AUDIENCE_RETARGETING_EDITOR,
    OpenAudienceRetargetingEditor,
    RESET_AUDIENCE_RETARGETING_EDITOR,
    ResetAudienceRetargetingEditor,
    RetargetingConditionsForAudienceEditorAction,
    UPDATE_GROUP_AUDIENCE_RETARGETING_EDITOR_CONDITION,
    UpdateGroupAudienceRetargetingEditorCondition
} from '../../actions/targetings/retargetingConditionsForAudienceEditor';
import { RetargetingAudienceEditorState } from '../../typings/retargeting';

const updateGroupAudienceRetargetingEditor = (
    state: RetargetingAudienceEditorState,
    action: UpdateGroupAudienceRetargetingEditorCondition
): RetargetingAudienceEditorState => {
    return {
        ...state,
        [action.groupId]: {
            ...action.conditionData,
            isDeleting: false
        }
    };
};

const clearGroupAudienceRetargetingEditor = (
    state: RetargetingAudienceEditorState,
    action: ClearGroupAudienceRetargetingEditorCondition
): RetargetingAudienceEditorState => {
    return {
        ...state,
        [action.groupId]: {
            ...state[action.groupId],
            isDeleting: true
        }
    };
};

const openAudienceRetargetingEditor = (
    state: RetargetingAudienceEditorState,
    action: OpenAudienceRetargetingEditor
): RetargetingAudienceEditorState => {
    return {
        ...state,
        [action.groupId]: {
            ...action.conditionData,
            isDeleting: false
        }
    };
};

const resetAudienceRetargetingEditor = (
    state: RetargetingAudienceEditorState,
    action: ResetAudienceRetargetingEditor
): RetargetingAudienceEditorState => {
    delete state[action.groupId];

    return state;
};

export function retargetingAudienceEditor(
    state: RetargetingAudienceEditorState = {},
    action: RetargetingConditionsForAudienceEditorAction
): RetargetingAudienceEditorState {
    switch (action.type) {
        case UPDATE_GROUP_AUDIENCE_RETARGETING_EDITOR_CONDITION:
            return updateGroupAudienceRetargetingEditor(state, action);

        case CLEAR_GROUP_AUDIENCE_RETARGETING_EDITOR_CONDITION:
            return clearGroupAudienceRetargetingEditor(state, action);

        case OPEN_AUDIENCE_RETARGETING_EDITOR:
            return openAudienceRetargetingEditor(state, action);

        case RESET_AUDIENCE_RETARGETING_EDITOR:
            return resetAudienceRetargetingEditor(state, action);

        default:
            return state;
    }
}
